import {
  FilterForm,
  IconFont,
  OptionType,
  PageContainer,
  SearchInput,
  SignTitle,
  TableTag,
  TagSearchOption,
} from '@/components'
import { useRequest } from 'ahooks'
import {
  Breadcrumb,
  Card,
  Input,
  Button,
  Popover,
  Form,
  Select,
  DatePicker,
  Typography,
  Checkbox,
  Pagination,
  Modal,
  Empty,
} from 'antd'
import React, { useEffect, useState } from 'react'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import Scrollbars from 'react-custom-scrollbars'
import { ShowTotal } from '@/components/show-total'
import { AddModal } from '@/pages/data-protection/template-resources/add-modal'
import { EditModal } from '@/pages/data-protection/template-resources/edit-modal'
import { DetailModal } from '@/pages/data-protection/template-resources/detail-modal'
import { GetTemplateList } from '@/api/dp-template'
import { useDeleteTemplate, useGetTemplateFormat, useGetTemplateList } from './utils'
import { useGetTagTreeOptions } from '../create-task/utils'
import { t } from '@/i18n'
const TemplateResource: React.FC = () => {
  // const { Search } = Input
  // const [searchForm] = Form.useForm()
  // const { state }: any = useLocation()
  const [addVisible, setAddVisible] = useState(false)
  let [editVisible, setEditVisible] = useState({ visible: false, id: null })
  let [detailVisible, setDetailVisible] = useState({ visible: false, id: null })

  const [filterParams, setFilterParams] = useState<GetTemplateList>({
    page: 1,
    limit: 10,
    // keyword: null,
    // is_parsing: null,
    // origin_type: null,
    // file_format: null,
  })
  // const [searchVisible, setSearchVisible] = useState(false)
  const [templateList, setTemplateList] = useGetTemplateList()
  const [deleteTemplate] = useDeleteTemplate()
  const [getTagTreeOptions, tagTreeOptions] = useGetTagTreeOptions()
  const [formatList] = useGetTemplateFormat()
  const [filterHeight, setFilterHeight] = useState(53)
  let [deleteVisible, setDeleteVisible] = useState({ visible: false, id: null })

  useEffect(() => {
    getTagTreeOptions({}).catch(_ => {})
  }, [])
  const del = id => {
    // 删除
    deleteTemplate({ id })
      .then(() => {
        setDeleteVisible({ visible: false, id: null })
        getList()
      })
      .catch(_ => {})
  }
  const onDetailClosed = () => {
    setDetailVisible({ visible: false, id: null })
  }
  const onAddFinished = (val = 1) => {
    if (val === 2) {
      // 添加成功
      getList()
    }
    setAddVisible(false)
  }
  const onEditFinished = (val = 1) => {
    setEditVisible({ visible: false, id: null })
    if (val === 2) {
      getList()
    }
  }

  const getList = () => {
    setTemplateList({
      ...filterParams,
      resource_tag_ids: filterParams?.resource_tag_ids?.map(item =>
        item.split('$').slice(1).join('$'),
      ),
    }).catch(_ => {})
  }
  useEffect(() => {
    getList()
  }, [filterParams])

  const objList = {
    keyword: {
      label: t('模板名称'),
      type: 'input',
    },
    origin_type: {
      type: 'radio',
      visible: false,
      label: t('模板来源'),
      data: [
        // { name: '全部', id: null, visible: false },
        { name: t('系统内置'), id: 1, visible: false },
        { name: t('自定义'), id: 2, visible: false },
      ],
    },
    is_parsing: {
      type: 'radio',
      visible: false,
      label: t('文件解析'),
      data: [
        // { name: '全部', id: null, visible: false },
        { name: t('可解析'), id: 1, visible: false },
        { name: t('不可解析'), id: 2, visible: false },
      ],
    },
    file_format: {
      type: 'radio',
      visible: false,
      label: t('文件格式'),
      data: [
        // { name: '全部', id: null, visible: false },
        ...formatList.map(item => ({ name: item, id: item, visible: false })),
        // { name: '有格式', id: 1, visible: false },
        // { name: '无格式', id: 2, visible: false },
      ],
    },
    resource_tag_ids: {
      label: t('用例标签'),
      type: 'treeSelect',
      typeof: 'array',
      data: TagSearchOption(tagTreeOptions),
    },
  } as OptionType

  return (
    <PageContainer>
      <TaskListContainer
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
            <SignTitle>{t('模板资源')}</SignTitle>{' '}
            <Button
              type={'primary'}
              onClick={() => {
                setAddVisible(true)
              }}
            >
              {t('添加自定义模板')}
            </Button>
          </div>
        }
        actions={[
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: 30 }}>
            <Pagination
              current={filterParams.page}
              pageSize={filterParams.limit}
              total={templateList.total}
              showTotal={total => <ShowTotal>{total}</ShowTotal>}
              showSizeChanger
              showQuickJumper
              onChange={(page, pageSize) => {
                setFilterParams(origin => ({ ...origin, page, limit: pageSize as number }))
              }}
            />
          </div>,
        ]}
      >
        <Task>
          <FilterForm
            option={objList}
            setFilterHeight={setFilterHeight}
            onReset={() => {
              setFilterParams({ page: 1, limit: 10 })
            }}
            setSearchParams={setFilterParams}
          />
        </Task>

        <Scrollbars style={{ height: 'calc(100% - 32px)' }}>
          <TemplateSlect>
            {templateList?.items?.map((item, index) => (
              <div
                key={index}
                className="item"
                onClick={() => {
                  setDetailVisible({ visible: true, id: item.id })
                }}
              >
                <div className="flex">
                  <div className="flex">
                    {item.origin_type === 1 ? (
                      <TableTag background="#558492" color="#fff" style={{ width: 60 }}>
                        {t('系统内置')}
                      </TableTag>
                    ) : (
                      <TableTag background="#ED787E" color="#fff" style={{ width: 60 }}>
                        {t('自定义')}
                      </TableTag>
                    )}
                    <Typography.Text
                      style={{ marginLeft: 6, width: 150, fontWeight: 500 }}
                      ellipsis={{ tooltip: item.name }}
                    >
                      {item.name}
                    </Typography.Text>
                  </div>
                  {item.origin_type === 2 && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <IconFont
                        style={{ cursor: 'pointer', marginRight: '10px', fontSize: '16px' }}
                        onClick={e => {
                          e.stopPropagation()
                          setEditVisible({ visible: true, id: item.id })
                        }}
                        type={'icon-bianji'}
                        className="delete-icon"
                      />
                      <IconFont
                        type={'icon-shanchu-m'}
                        className="delete-icon"
                        onClick={e => {
                          e.stopPropagation()
                          setDeleteVisible((deleteVisible = { visible: true, id: item.id }))
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="item-main">
                  <div className="item-img">
                    <img
                      width={64}
                      height={64}
                      src={`${process.env.NODE_ENV === 'dev' ? '/api' : ''}${item.cover}`}
                      alt=""
                    />
                  </div>
                  <div className="item-right">
                    {[1, 2, 3].includes(item.file_type) && (
                      <div className="analysis">{t('可解析')}</div>
                    )}
                    {item.file_type === 4 && <div className="analysis">{t('不可解析')}</div>}
                    <div className="bmp">{item.file_name}</div>
                  </div>
                </div>
              </div>
            ))}
          </TemplateSlect>
          {(!templateList?.items?.length || templateList?.items?.length === 0) && (
            <Empty image={EmptyImg} />
          )}
        </Scrollbars>
      </TaskListContainer>
      {addVisible && <AddModal visible={addVisible} setVisible={onAddFinished} />}
      {editVisible.visible && <EditModal setVisible={onEditFinished} id={editVisible.id} />}
      {detailVisible.visible && <DetailModal setVisible={onDetailClosed} id={detailVisible.id} />}
      <Modal
        centered
        title={<SignTitle show>{t('提示')}</SignTitle>}
        visible={deleteVisible.visible}
        onOk={() => del(deleteVisible.id)}
        onCancel={() => setDeleteVisible((deleteVisible = { visible: false, id: [] }))}
      >
        <Icon type={'icon-tixingshixin'} />
        <span>{t('此操作将永久删除该模板,是否继续?')}</span>
      </Modal>
    </PageContainer>
  )
}
export default TemplateResource
const TaskListContainer = styled(Card)`
  min-height: 100%;
  width: 100%;
  .ant-card-actions {
    border-radius: 8px;
  }
  .ant-card-body {
    padding: 0;
  }
  .flex {
    display: flex;
  }
  .justify-right {
    justify-content: right;
  }
  .ant-card-body {
    display: flex;
    flex-wrap: wrap;
  }
  .ant-input-wrapper {
    width: 230px;
    height: 32px;
    button {
      width: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #2973ff;
      border-radius: 4px !important;
      .anticon-search {
        color: #fff;
      }
    }
  }
`
const Task = styled.div`
  flex-grow: 1;
  /* height: 100%;
  .refreshButton {
    border: 0px;
    background: #f1f3f8;
    &:hover {
      color: #0b0a27;
      background: #e2e4f6;
    }
  } */
`

const TemplateSlect = styled.div`
  display: grid;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
  margin-top: 2px;
  grid-gap: 0 20px;
  padding: 0 20px;
  .item {
    width: 100%;
    height: 142px;
    padding: 12px;
    background: #f7f7f9;
    border-radius: 8px;
    margin-bottom: 20px;
    border: 1px solid #d9d9d9;
    .flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .ant-checkbox-inner {
        width: 24px;
        height: 24px;
        &::after {
          left: 30.5%;
        }
      }
    }
    .item-main {
      height: 84px;
      background: #ffffff;
      border-radius: 8px;
      margin-top: 10px;
      display: flex;
      .item-img {
        width: 88px;
        padding: 10px 12px;
      }
      .item-right {
        //width: 100%;
        width: calc(100% - 88px);
        height: 84px;
        background: #ffffff;
        border-left: 1px solid #e8e8f0;
        border-radius: 0 8px 8px 0;
        .analysis,
        .bmp {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          height: 42px;
          width: 100%;
          padding-left: 12px;
          line-height: 42px;
          //display: flex;
          //align-items: center;
        }
        .analysis {
          border-bottom: 1px solid #e8e8f0;
        }
      }
    }
    .delete-icon {
      color: #999999;
      &:hover {
        color: #2e3d5e;
      }
    }
  }
`
const Icon = styled(IconFont)`
  color: #faad14;
  font-size: 18px;
  margin-right: 12px;
  transform: translateY(2px);
`
